import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Download } from '../Download/Download';

export const DownloadField = ({
  title,
  description,
  fileName,
  downloadUrl: directDownloadUrl,
  uploadId,
  getCandidateUpload,
}) => {
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (uploadId && getCandidateUpload) {
      setLoading(true);
      Promise.resolve(getCandidateUpload(uploadId))
        .then(upload => {
          setDownloadUrl(upload?.url || null);
        })
        .catch(error => {
          console.error('Error fetching upload URL:', error);
          setDownloadUrl(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setDownloadUrl(directDownloadUrl || null);
      setLoading(false);
    }
  }, [uploadId, getCandidateUpload, directDownloadUrl]);

  if (!getCandidateUpload && uploadId) {
    console.warn('getCandidateUpload not available for Download field with uploadId:', uploadId);
  }

  return (
    <Download
      title={title}
      description={description}
      fileName={fileName}
      downloadUrl={loading ? null : downloadUrl}
    />
  );
};

DownloadField.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  fileName: PropTypes.string,
  downloadUrl: PropTypes.string,
  uploadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  getCandidateUpload: PropTypes.func,
};
